export type NavBannerStatus = 'active' | 'inactive';

export interface NavBannerDefinition {
  id: string;
  status: NavBannerStatus;
  href: string;
  messageKey: string;
  mobileMessageKey?: string;
  ctaKey: string;
  mobileCtaKey?: string;
  dismissKey: string;
}

export interface NavBannerContent {
  id: string;
  href: string;
  message: string;
  mobileMessage: string;
  ctaLabel: string;
  mobileCtaLabel: string;
  dismissLabel: string;
}

export const NAV_BANNER_REGISTRY: readonly NavBannerDefinition[] = [
  {
    id: 'music-waitlist',
    status: 'active',
    href: 'https://docs.google.com/forms/d/e/1FAIpQLSdgUQxAYzmm7zHhV4Pr9L2Sz9Qx45fsIdPRJ-ZfYDn9E2vcfw/viewform?usp=publish-editor',
    messageKey: 'nav.musicPromo.desktop',
    mobileMessageKey: 'nav.musicPromo.mobile',
    ctaKey: 'nav.musicPromo.joinWaitlist',
    mobileCtaKey: 'nav.musicPromo.join',
    dismissKey: 'nav.musicPromo.dismiss',
  },
] as const;

export function getActiveNavBanners(t: (key: string) => string): NavBannerContent[] {
  return NAV_BANNER_REGISTRY.filter((banner) => banner.status === 'active').map((banner) => ({
    id: banner.id,
    href: banner.href,
    message: t(banner.messageKey),
    mobileMessage: t(banner.mobileMessageKey ?? banner.messageKey),
    ctaLabel: t(banner.ctaKey),
    mobileCtaLabel: t(banner.mobileCtaKey ?? banner.ctaKey),
    dismissLabel: t(banner.dismissKey),
  }));
}
